import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { SharedModule } from '../../../shared';
import { TranslateModule } from '@ngx-translate/core';
import { RainExercisePage } from './rain-exercise';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [
    RainExercisePage
  ],
  imports: [
    IonicModule,
    CommonModule,
    RouterModule.forChild([{ path: '', component: RainExercisePage }]),
    TranslateModule.forChild(),
    SharedModule
  ],
  exports: [
    RainExercisePage
  ]
})
export class RainExercisePageModule {}
